<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-number"><span><a href="#/toc#toc-part001"><img alt="image" src="images/part1.jpg" style="max-width:98%; max-height:98%;"/></a></span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?0959119d